import { renderSpacerBlock } from '../render/blocks/spacer';
import { SpacerBlockSettings } from '../settings/blocks/spacer';
import { defineBlockRegistryEntry } from './defineEntry';
import { spacerBlockDefinition } from '../domain/blocks/spacer';

export const spacerBlockRegistryEntry = defineBlockRegistryEntry(
  spacerBlockDefinition,
  renderSpacerBlock,
  SpacerBlockSettings,
);
